export const STEP_LOADING = 'loading';
export const STEP_START = 'start';
export const STEP_WALLET = 'wallet';
export const STEP_BULK_ORDER = 'bulk-order';
export const STEP_ICONS = 'icons';
export const STEP_TEXT = 'text';
export const STEP_MONOGRAM = 'monogram';
export const STEP_REVIEW = 'review';
export const PLACEMENT_PRODUCT = 'Product';
export const PLACEMENT_COLORS = 'Colors';
export const DEFINITION_COLOR = 'Color';
export const DEFINITION_PRODUCT = 'Product Component';

export const ProductType = {
    WALLET: 'Wallet',
    RING: 'Ring',
};
